import { API_URL } from "./env.js";

const SESSION_API_URL = `${API_URL}/session`;

export async function getSessionToken(email) {
    return fetch(SESSION_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({email})
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json().then(data => data.sessionId);
        })
        .catch(error => {
            console.error('Error getting session     token:', error);
            throw error;
        }); 
}

export async function authenticate(sessionToken) {
    return fetch(SESSION_API_URL, {
        headers: {
            'Authorization': `Bearer ${sessionToken}`
        }
    })
}